module.exports = __webpack_public_path__ + "static/media/logo-rambody-text-white.c792b75a.png";